export default __webpack_public_path__ + "static/heroImage-d543e55eb529270113ddb2897d5cbd2a.svg";